import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import ColorWrapper from '@styles/colors';
import BaseFrame from '@components/settings/components/modules/baseFrame';

import { getTimezone, updateCompanyProfileValue } from '@reducers/membership';

const BaseModal = (props) => {
  const { selectedValue, getTimezone, change } = props;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    (async () => {
      const d = await getTimezone();
      if (d) {
        const mappedData = d.map((i) => ({ name: i.name, value: i.id }));
        setData(mappedData);

        // Find matching timezone ID by name
        if (selectedValue) {
          const matchedTimezone = d.find((i) => i.name === selectedValue);
          if (matchedTimezone) {
            setSelected(matchedTimezone.id);
          }
        }
      }
      setLoading(false);
    })();
  }, []);

  const onSelect = (item) => {
    setSelected(item.value);
  };

  const onCancel = () => {};

  const onSubmit = async () => {
    setSubmitLoading(true);
    // Find the timezone name from the selected ID
    const selectedTimezone = data.find((item) => item.value === selected);
    change(selectedTimezone ? selectedTimezone.name : selected);
    setSubmitLoading(false);
  };

  return (
    <BaseFrame
      {...{
        loading,
        submitLoading,
        data,
        onCancel,
        onSelect,
        onSubmit,
        header: 'Time Zone',
        selected,
        ...props,
      }}
    />
  );
};

export default connect(({ user }) => ({ user }), { getTimezone, updateCompanyProfileValue })(ColorWrapper(BaseModal));
